import { useApiGet } from "@/hooks/useApi";
import { getCourseUnits } from "../api";

export function useGetCourseUnits({ courseSlug }) {
	const { data, isPending, isSuccess, isError, error } = useApiGet({
		key: ["courses", courseSlug, "units", "list"],
		fn: () => getCourseUnits({ courseSlug }),
		options: {
			staleTime: 60 * 1000,
			gcTime: 5 * 60 * 1000,
		},
	});

	return { ...data, isPending, isSuccess, isError, error };
}
